<template>
  <div v-if="quote">
    <h1>Schedule emails</h1>
    <div>
      Working on quote:&#160;
      <router-link :to="{ name: 'quote', params: { id: $route.params.id } }">{{
        $route.params.id
      }}</router-link>
    </div>

    <div v-if="quote.emailTemplates && !quote.emailTemplates.length">
      <br />
      <h3>No email templates</h3>
    </div>

    <div v-if="quote.emailTemplates && quote.emailTemplates.length">
      <div class="ajaxForm" v-if="activeEmails" style="margin-bottom: 10px">
        <h3>Choose email addresses:</h3>
        <v-checkbox
          v-model="selectedEmails"
          :label="`${email.address} (${email.personal})`"
          :value="email.id"
          v-for="email in activeEmails"
          :key="email.id"
        />
      </div>

      <h3>Choose email templates:</h3>
      <div
        v-for="emailTemplate in emailTemplatesCopy"
        :key="emailTemplate.id"
        style="margin-bottom: 10px"
      >
        <div class="box-widget">
          <div class="heading">
            {{ emailTemplate.subject }}
          </div>
          <v-checkbox
            v-model="emailTemplate.selected"
            :label="emailTemplate.scheduleText"
          ></v-checkbox>
          <v-spacer></v-spacer>
          <v-icon
            v-if="!emailTemplate.show"
            @click="emailTemplate.show = true"
            x-large
            >expand_more</v-icon
          >
          <v-icon
            v-if="emailTemplate.show"
            @click="emailTemplate.show = false"
            x-large
            >expand_less</v-icon
          >
        </div>
        <v-divider v-if="emailTemplate.show"></v-divider>
        <v-card v-if="emailTemplate.show">
          <v-card-text
            ><v-select
              label="Format"
              v-model="emailTemplate.type"
              :items="types"
              item-value="id"
              item-text="name"
              outline
            >
            </v-select>
            <div
              v-html="emailTemplate.html"
              v-if="emailTemplate.type == 'html'"
            ></div>
            <div
              style="white-space: pre-wrap"
              v-if="emailTemplate.type == 'text'"
            >
              {{ emailTemplate.text }}
            </div>
          </v-card-text>
        </v-card>
      </div>

      <div>
        <v-btn @click="sendEmail" color="info" :disabled="submitted">
          <v-icon>send</v-icon>Send
        </v-btn>
        <v-btn @click="navigate"> <v-icon>undo</v-icon>Cancel </v-btn>
      </div>
    </div>

    <v-snackbar
      v-model="snackbar"
      :multi-line="false"
      :timeout="1500"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import QUOTE_SCHEDULEEMAILS from "@/graphql/sales/QuoteScheduleEmails";
import UPDATE_QUOTE_EMAIL_QUOTE from "@/graphql/sales/UpdateQuoteEmailQuote";
export default {
  name: "ScheduleEmails",
  metaInfo() {
    return {
      title: "Schedule emails",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    quote: {
      query: QUOTE_SCHEDULEEMAILS,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      activeEmails: null,
      emailTemplatesCopy: null,
      emailTemplateId: null,
      selectedEmails: [],
      types: [
        { id: "html", name: "HTML" },
        { id: "text", name: "Text" }
      ],
      snackbar: false,
      snackbarText: null,
      submitted: false
    };
  },
  methods: {
    async sendEmail() {
      try {
        this.submitted = true;
        const selectedRevisions = this.emailTemplatesCopy
          .filter((et) => et.selected)
          .map((et) => et.revisionid);
        if (!selectedRevisions || !selectedRevisions.length) {
          this.snackbar = true;
          this.snackbarText = "Please select at least one template";
          this.submitted = false;
          return;
        }
        if (!this.selectedEmails || !this.selectedEmails.length) {
          this.snackbar = true;
          this.snackbarText = "Please select at least one email address";
          this.submitted = false;
          return;
        }
        await this.$apollo.mutate({
          mutation: UPDATE_QUOTE_EMAIL_QUOTE,
          variables: {
            id: Number(this.$route.params.id),
            selectedEmails: this.selectedEmails,
            selectedRevisions
          }
        });
        this.navigate();
      } catch (err) {
        this.submitted = false;
      }
    },
    navigate() {
      this.$router.push({
        name: "quote",
        params: { id: this.$route.params.id }
      });
    }
  },
  watch: {
    quote: {
      handler() {
        this.emailTemplatesCopy = this.quote.emailTemplates.map((et) => {
          const scheduleText = `Send ${
            et.emailTemplateRevision.schedule == 0
              ? "immediately"
              : `in ${et.emailTemplateRevision.schedule} day(s)`
          }`;
          const subject = et.emailTemplateRevision.subject;
          return {
            id: et.id,
            revisionid: et.emailTemplateRevision.id,
            html: et.html,
            text: "HTML",
            type: "html",
            show: false,
            selected: et.selectedByDefault,
            scheduleText,
            subject
          };
        });
        this.activeEmails = this.quote.quoteEmails
          .filter((qe) => !qe.archived)
          .map((qe) => qe.email);
        this.selectedEmails = this.activeEmails.map((e) => e.id);
      }
    }
  }
};
</script>

<style scoped>
.box-widget {
  display: flex;
  padding: 10px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.box-widget .heading {
  display: inline-block;
  margin: auto 15px auto 0px;
  font-size: 1.2em;
}
</style>